<template>
  <div>
    <!-- Page Preloder -->
    <div id="preloder" v-if="loader">
      <div class="loader"></div>
    </div>
    <Header />
    <LoginForm @loginUser="onSubmit" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import LoginForm from '../components/LoginForm.vue'
import Header from '@/components/HeaderComponentOne.vue'

export default {
  name: 'Login',
  components: {
    LoginForm,
    Header,
  },

  data() {
    return {
      loader: false,
      passwordType: false,
      userDetails: {
        email: '',
        password: '',
      },
      loginError: '',
      disabled: false,
      from: null,
    }
  },

  beforeRouteEnter(to, from, next) {
    if (to.query.redirectFrom == '/dashboard/user') {
      next((vm) => {
        console.table(to.query.redirectFrom)
        vm.from = to.query.redirectFrom
        vm.$moshaToast(`Login to View Dashboard`, {
          hideProgressBar: true,
          type: 'info',
          position: 'top-right',
        })
      })
    } else if (
      to.query.redirectFrom !== '/dashboard/user' &&
      to.query.redirectFrom !== undefined &&
      to.query.redirectFrom !== '/wallet'
    ) {
      next((vm) => {
        vm.from = to.query.redirectFrom
        vm.$moshaToast(`Login to Join Us`, {
          hideProgressBar: true,
          type: 'info',
          position: 'top-right',
        })
      })
    } else {
      
      next()
    }
  },

  computed: {
    ...mapState('auth', ['access_token', 'auth']),
    ...mapState('merchants', ['merchant', 'isMerchantDashboard']),
  },

  methods: {
    ...mapActions('auth', ['login']),
    ...mapActions('auth', ['getOptions']),

    async onSubmit(data) {
      try {
        // Show loader
        this.loader = true

        // Make request
        let response = await this.login(data)
        this.makeToast(
          `Welcome ${response.data.user.firstname}`,
          'Login successful',
          'success',
        )


        // get user options
        // this.getOptions()

        // Check redirect
        if (this.from) {
          this.$router.push(this.from)
        } else {
          if(this.isMerchantDashboard){
          this.$router.push('/merchants/products')
          } else {
            this.$router.push('/dashboard/overview')
          }
        }
        this.loader = false
      } catch (error) {
        // Handle error
        this.loader = false
        this.loginError = error.response.data.message
        this.$moshaToast(`${this.loginError}`, {
          hideProgressBar: true,
          type: 'danger',
          position: 'top-right',
        })
      }
    },
  },

  async created() {},
}
</script>
